<template>
  <div/>
</template>

<script>

export default {
  components: {},
  data () {
    return {
      option: {
        is1Button: true,
        buttonLabel: '閉じる',
        callback: 'ChangeEmailFinish',
        callbackO: 'Finish',
        messages: ['メールアドレスの変更が完了しました', '再度、サインインしてください']
      },
      optionTokenError: {
        is1Button: true,
        buttonLabel: '閉じる',
        buttonColor: 'b',
        callback: 'TokenError',
        callbackO: 'close',
        messages: ['リンクの有効期限が切れました', '再度、メールアドレスの変更手続きを行ってください']
      },
      lock: false
    };
  },
  created: function () {
    this.emailVerify();
  },
  watch: {
    lock: function () {
      // ローディング表示
      if (this.lock === true) {
        this.$store.dispatch('loading/open').then();
      } else {
        this.$store.dispatch('loading/close').then();
      }

    },
    callbackDispatcher: function () {
      console.log(this.callbackDispatcher);

      if(this.callbackDispatcher === 'ChangeEmailFinish'){
        // SingInへ遷移
        this.$router.push({name: 'SingIn'});
      } else{
        // Welcomeへ遷移
        this.$router.push({name: 'Welcome'});
      }

    }
  },
  computed: {
    callbackDispatcher: function () {
      return this.$store.getters['message/callback'];
    }
  },
  methods: {
    emailVerify: function () {
      console.log('emailVerify');

      let token = this.$route.params.token;
      let session = this.$route.params.session;

      let params = {v: token, s: session};
      console.log(params);

      // ロック
      this.lock = true;

      this.$store.dispatch('user/verifyEmail', params).then(() => {

        let status = this.$store.getters['user/status'];

        if (status === 200) {

          // 認証リセット
          this.$store.dispatch('auth/reset').then();

          // 完了メッセージ
          this.$store.dispatch('message/open', this.option).then();

        } else{
          // 期限切れメッセージ
          this.$store.dispatch('message/open', this.optionTokenError).then();
        }

        // ロック解除
        this.lock = false;

      }).catch((err) => {
        console.warn(err);

        // ロック解除
        this.lock = false;

        this.$store.dispatch('errorInfo/setSystemErrorMessage').then();
        this.$router.push({name: 'UserSystemError'});
      });
    }
  }
};

</script>

<style lang="scss" scoped>

  .form-helper-container {
    margin-top: 120px;
  }

  .form-container {
    border: 1px solid #ddd;
  }

  // 801以上
  @media screen and (min-width: 801px) {

  }

  // 800まで
  @media screen and (max-width: 800px) {
  }

</style>
